import React from "react";
import Modal from "../../../components/Modal";
import { IProps } from "./interfaces";

import LoadingComponent from "./loadable";

export default (props: IProps) => (
    <Modal width="auto" close={props.close}>
        <LoadingComponent {...props} />
    </Modal>
);
